import PropTypes from "prop-types";
import React from "react";

import { Section } from "@swa-ui/core";
import { CheckboxFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./AccessibilityAccommodationsFormFields.module.scss";
import { ACCESSIBILITY_ACCOMMODATIONS_SCHEMA_FIELD_NAMES } from "./AccessibilityAccommodationsFormFields.schema";

const { COGNITIVE_DISABILITY, HEARING_DISABILITY, VISION_DISABILITY } =
  ACCESSIBILITY_ACCOMMODATIONS_SCHEMA_FIELD_NAMES;

export const AccessibilityAccommodationsFormFields = (props) => {
  const {
    cognitiveDisabilityAssistanceFieldName = COGNITIVE_DISABILITY,
    hearingDisabilityAssistanceFieldName = HEARING_DISABILITY,
    visionDisabilityAssistanceFieldName = VISION_DISABILITY,
  } = props;

  return <Section {...getSectionProps()}>{renderDisabilityTypes()}</Section>;

  function renderDisabilityTypes() {
    const disabilityTypes = [
      {
        infoPlacementId: "disabilityOptionBlind",
        label: "AccessibilityAccommodationsFormFields__VISION_DISABILITY",
        name: visionDisabilityAssistanceFieldName,
      },
      {
        infoPlacementId: "disabilityOptionDeaf",
        label: "AccessibilityAccommodationsFormFields__HEARING_DISABILITY",
        name: hearingDisabilityAssistanceFieldName,
      },
      {
        infoPlacementId: "disabilityOptionCognitive",
        label: "AccessibilityAccommodationsFormFields__COGNITIVE_DISABILITY",
        name: cognitiveDisabilityAssistanceFieldName,
      },
    ];

    return disabilityTypes.map((type) => (
      <CheckboxFormField {...getCheckboxFormFieldProps(type)} key={type.name} />
    ));
  }

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("AccessibilityAccommodationsFormFields__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "small",
      },
    };
  }

  function getCheckboxFormFieldProps(options) {
    const { label, name, infoPlacementId } = options;

    return {
      className: styles.checkboxFormField,
      componentProps: {
        label: <PlacementInfoLabel label={label} placementId={infoPlacementId} />,
      },
      hideBottomSection: true,
      name,
    };
  }
};

export const accessibilityAccommodationsFormFieldsPropTypes = {
  /** Field name for cognitive disability assistance checkbox. */
  cognitiveDisabilityAssistanceFieldName: PropTypes.string,

  /** Field name for hearing disability assistance checkbox. */
  hearingDisabilityAssistanceFieldName: PropTypes.string,

  /** Field name for vision disability assistance checkbox. */
  visionDisabilityAssistanceFieldName: PropTypes.string,
};

AccessibilityAccommodationsFormFields.propTypes = accessibilityAccommodationsFormFieldsPropTypes;
